module.exports = __webpack_public_path__ + "img/맥형아카데미_4.4bb5b14e.jpg";